import { render } from "./AlarmCard.vue?vue&type=template&id=41b408de&scoped=true&ts=true"
import script from "./AlarmCard.vue?vue&type=script&lang=ts"
export * from "./AlarmCard.vue?vue&type=script&lang=ts"

import "./AlarmCard.vue?vue&type=style&index=0&id=41b408de&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b408de"]])

export default __exports__